import React, { useState } from 'react';
import { deleteAdminUser } from '../../services/AdminUserApi';
import './DeleteConfirmModal.css';
import Swal from 'sweetalert2';

const DeleteConfirmModal = ({ isOpen, user, onClose, onSuccess }) => {
  const [submitting, setSubmitting] = useState(false);

  if (!isOpen) return null;

  const handleDelete = async () => {
    try {
      setSubmitting(true);
      await deleteAdminUser(user.email);
      Swal.fire({
        title: "Deleted Successfully",
        text: "Admin user deleted successfully",
        icon: "success",
      });
  
      onSuccess();
    } catch (error) {
      const errorMsg = error.response?.data?.activatedMessage || 
                      error.response?.data?.message ||
                      'Failed to delete admin user';

                      Swal.fire({
                        title: "Error",
                        text: errorMsg,
                        icon: "error",
                        confirmButtonText: "OK",
                      }); 
                    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="modal-overlay" >
      <div className="modal-content delete-modal" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2>⚠️ Delete Admin User</h2>
          <button className="modal-close" onClick={onClose}>×</button>
        </div>

        <div className="modal-body">
          <p className="warning-text">
            Are you sure you want to delete the following admin user?
          </p>
          
          <div className="user-info-box">
            <div className="user-info-row">
              <strong>Email:</strong>
              <span>{user.email}</span>
            </div>
            <div className="user-info-row">
              <strong>Role:</strong>
              <span className={`role-${user.role.toLowerCase()}`}>
                {user.role}
              </span>
            </div>
            <div className="user-info-row">
              <strong>Status:</strong>
              <span>{user.status}</span>
            </div>
          </div>

          <p className="danger-text">
            ⚠️ This action cannot be undone. The user will lose all admin access immediately.
          </p>
        </div>

        <div className="modal-footer">
          <button
            type="button"
            className="btn-secondary"
            onClick={onClose}
            disabled={submitting}
          >
            Cancel
          </button>
          <button
            type="button"
            className="btn-danger"
            onClick={handleDelete}
            disabled={submitting}
          >
            {submitting ? 'Deleting...' : 'Delete Admin User'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default DeleteConfirmModal;

